import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Slide, SlideAction } from '../../common/models';
import { Category } from './category.model';


@Injectable()
export class CategoryFormService {
  constructor(private fb: FormBuilder) {}

  getForm(category: Category = new Category()): FormGroup {
    return this.fb.group({
      _id: [category._id],
      name: [category.name, Validators.required],
      slug: [category.slug, Validators.required],
      image: [category.image],
      metaTitle: [category.metaTitle],
      metaDescription: [category.metaDescription],
      active: [category.active],
      discontinued: [category.discontinued],
      showFilters: [category.showFilters],
      slides: this.fb.array(category.slides.map(item => this.getSlideForm(item)))
    });
  }

  getSlideForm(slide: Slide = new Slide()): FormGroup {
    return this.fb.group({
      _id: [slide._id],
      image: [slide.image],
      video: [slide.video],
      mediaPosition: [slide.mediaPosition],
      title: [slide.title],
      content: [slide.content],
      secondaryContent: [slide.secondaryContent],
      contentPosition: [slide.contentPosition],
      backgroundImage: [slide.backgroundImage],
      backgroundVideo: [slide.backgroundVideo],
      backgroundPosition: [slide.backgroundPosition],
      backgroundColor: [slide.backgroundColor],
      backgroundPatternAligment: [slide.backgroundPatternAligment],
      backgroundPatternStyle: [slide.backgroundPatternStyle],
      backgroundColorAlias: [slide.backgroundColorAlias, Validators.required],
      backgroundFixed: [slide.backgroundFixed],
      height: [slide.height],
      textColor: [slide.textColor],
      textBackground: [slide.textBackground],
      actions: this.fb.array(slide.actions.map(item => this.getSlideActionForm(item))),
      actionsAlign: [slide.actionsAlign],
      position: [slide.position],
      active: [slide.active],
      vintageMode: [slide.vintageMode]
    });
  }

  getSlideActionForm(slideAction: SlideAction = new SlideAction()) {
    return this.fb.group({
      _id: [slideAction._id],
      icon: [slideAction.icon],
      label: [slideAction.label],
      type: [slideAction.type],
      image: [slideAction.image],
      video: [slideAction.video],
      backgroundImage: [slideAction.backgroundImage],
      backgroundVideo: [slideAction.backgroundVideo],
      colorPrimary: [slideAction.colorPrimary],
      colorSecondary: [slideAction.colorSecondary],
      url: [slideAction.url],
      youtubeCode: [slideAction.youtubeCode],
      poster: [slideAction.youtubePoster],
      anchor: [slideAction.anchor],
      anchorSection: [slideAction.anchorSection],
      position: [slideAction.position],
      style: [slideAction.style]

    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/categories/shared/category-form.service.ts